'use client';

import useSWR from 'swr';
import {
  Body,
  Container,
  SearchForm,
  SearchResultRow,
  SimpleHero
} from '@stereoagency/ui';
import { useContext, useEffect } from 'react';
import { useInfiniteHits, useSearchBox } from 'react-instantsearch-hooks-web';
import useTranslation from 'next-translate/useTranslation';
import { PagePatternContext } from '@/components/layout/PagePattern';
import { RouteResultType } from '@/app/(root)/api/search/results/route';
import { createDocumentURL } from '@/utils';

const hitsFetcher = async ([csvIds, language]: [string, string]) => {
  const url = new URL('/api/search/results', window.location.href);
  url.searchParams.append('ids', csvIds);
  url.searchParams.append('language', language);
  const response = await fetch(url.toString());
  const data = await response.json();
  return data as RouteResultType;
};

export default function SearchPageContent() {
  const { t, lang } = useTranslation('search');
  const { set: setPattern } = useContext(PagePatternContext);
  const { query, refine } = useSearchBox();
  const { hits } = useInfiniteHits();
  const { data, isLoading } = useSWR(
    query.length === 0
      ? null
      : [hits.map((hit) => hit.objectID).join(','), lang],
    hitsFetcher
  );

  useEffect(() => {
    setPattern('1');
  }, []);

  return (
    <>
      <SimpleHero title={t('title')} />

      <Container>
        <SearchForm
          loading={isLoading}
          action={{
            label: 'Recherche'
          }}
          placeholder={t('placeholder')}
          onSubmit={({ query: q }) => refine(q)}
        />
      </Container>

      <Container>
        {data && data.length === 0 && (
          <Body className="text-center">{t('empty')}</Body>
        )}
        <div>
          {data?.map((result) => (
            <SearchResultRow
              key={result._id}
              title={result.title}
              description={result.description}
              action={{
                href: createDocumentURL(lang, result._type, result.slug.current)
              }}
            />
          ))}
        </div>
      </Container>
    </>
  );
}
